import React, { PureComponent } from 'react';

import SelectBox from 'devextreme-react/select-box';

import CoreUtils from '../utils/CoreUtils';

export default class SelectEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.onControlValueListener = this.onControlValueChanged.bind(this);
  }

  render() {
    return (
      <SelectBox
        className="pwx-select-editor"
        dataSource={this.props.options}
        displayExpr={this.props.displayExpr}
        disabled={this.props.disabled}
        dropDownOptions={this.props.dropDownOptions}
        height={this.props.height}
        showClearButton={this.props.showClearButton}
        value={this.props.value}
        onValueChanged={this.onControlValueListener}
        width={this.props.width}
      />
    );
  }

  onControlValueChanged(event) {
    var value = event.value;
    if (CoreUtils.isDefinedAndNotNull(this.props.postEditFilter))
      value = this.props.postEditFilter(value);

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, value);
  }
}